import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const replaceBillingProfileWithExisting =
  (apiUrl) => (id, existingProfileId) => {
    const url = joinUrl(
      apiUrl,
      `/checkoutservice/pb/billing-profiles/${id}/replace-with-existing/`
    );
    return requestUtility.post(url, { existing_profile_id: existingProfileId });
  };

export default replaceBillingProfileWithExisting;
